import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, reset } from 'redux-form';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import * as rules from '../../../common/services/ValidationRules';
import Button from '../../../common/components/Button/Button';
import { FormInput } from '../../../common/components/TextField/TextField';
import { forgetPassword } from '../actions';
import { title } from './ResetPassword';
import LoginFormWrapper from './LoginFormWrapper';

const formId = 'forgot-password-form';

function ForgotPassword({ handleSubmit, isFetching }) {
  const navigate = useNavigate();

  const backToLogin = () => {
    navigate('/login');
  };

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <Field
        name="email"
        label="Email"
        type="email"
        fullWidth
        required
        disabled={isFetching}
        component={FormInput}
        validate={[rules.required, rules.email]}
      />
      <div className="login-form-btns">
        <div className="login-btns">
          <Button type="submit" color="primary" variant="contained">
            Submit
          </Button>
          <Button type="button" color="secondary" variant="contained" onClick={backToLogin}>
            Back to login
          </Button>
        </div>
      </div>
    </form>
  );
}

const ForgotPasswordForm = reduxForm({ form: formId })(ForgotPassword);

function ForgotPasswordPage({ forgetPassword, reset }) {
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [submitted, setSubmitted] = useState('');

  useEffect(() => {
    reset();
  }, []);

  const submitHandler = ({ email }) => {
    setIsFetching(true);
    setErrorMessage('');
    forgetPassword({ email })
      .then(() => {
        setIsFetching(false);
        setErrorMessage('');
        setSubmitted(email);
      })
      .catch(() => {
        setIsFetching(false);
        setErrorMessage('Password reset failed');
        setSubmitted('');
      });
  };

  return (
    <LoginFormWrapper
      title={title}
      backToLoginBtn={submitted}
      isFetching={isFetching}
      error={errorMessage || ''}
      text={submitted ? 'Please check your email for further instructions.' : undefined}
    >
      {!submitted && <ForgotPasswordForm onSubmit={submitHandler} submitted={submitted} isFetching={isFetching} />}
    </LoginFormWrapper>
  );
}

ForgotPasswordPage.propTypes = {
  forgetPassword: PropTypes.func,
  reset: PropTypes.func,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  forgetPassword: (data) => dispatch(forgetPassword(data)),
  reset: () => dispatch(reset(formId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);
